import React from "react";
import { useOptInStore } from "../store";
import { DisplayType, UserInfoFormikValues } from "../types";
import { UserInfoFormik } from "./user-info-formik";
import { UserInfoFormikWithEmail } from "./user-info-formik-with-email";

interface InitialStepProps {
  name: string;
  privacyUrl: string;
  tosUrl: string;
  phone: string;
  discountText: string;
  showDiscountText: boolean;
  title: string;
  body: string;
  termsOfService: string;
  display: DisplayType;
  onSubmit: (values: UserInfoFormikValues) => Promise<void>;
}

export function InitialStep(props: InitialStepProps) {
  const submissionError = useOptInStore((state) => state.submissionError);
  return (
    <div>
      <div className="text-center space-y-2">
        <h1 className="display-medium text-body">{props.title}</h1>
        <p className="body text-body">{props.body}</p>
      </div>
      {submissionError && (
        <p className="text-critical text-sm my-2">{submissionError}</p>
      )}
      {props.showDiscountText && (
        <div className="mt-4">
          <div className="py-4 px-2 body text-center promo-well bg-opacity-20 text-[#212121]">
            <p>{props.discountText}</p>
          </div>
        </div>
      )}
      <div className="mt-4">
        {props.display === "page" && (
          <UserInfoFormikWithEmail
            name={props.name}
            tosUrl={props.tosUrl}
            privacyUrl={props.privacyUrl}
            phone={props.phone}
            onSubmit={props.onSubmit}
          />
        )}
        {props.display === "modal" && (
          <UserInfoFormik
            name={props.name}
            tosUrl={props.tosUrl}
            privacyUrl={props.privacyUrl}
            onSubmit={props.onSubmit}
            phone={props.phone}
            termsOfService={props.termsOfService}
          />
        )}
      </div>
    </div>
  );
}
